// @generated by protoc-gen-es v2.10.2 with parameter "target=ts"
// @generated from file jira/v1/jira_service.proto (package jira.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import { file_google_protobuf_struct } from "@bufbuild/protobuf/wkt";
import type { JsonObject, Message } from "@bufbuild/protobuf";

/**
 * Describes the file jira/v1/jira_service.proto.
 */
export const file_jira_v1_jira_service: GenFile = /*@__PURE__*/
  fileDesc("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", [file_google_protobuf_struct]);

/**
 * @generated from message jira.v1.Credentials
 */
export type Credentials = Message<"jira.v1.Credentials"> & {
  /**
   * @generated from field: string site_domain = 1;
   */
  siteDomain: string;

  /**
   * @generated from field: jira.v1.AuthType auth_type = 2;
   */
  authType: AuthType;

  /**
   * @generated from field: string email = 3;
   */
  email: string;

  /**
   * @generated from field: string api_key = 4;
   */
  apiKey: string;
};

/**
 * Describes the message jira.v1.Credentials.
 * Use `create(CredentialsSchema)` to create a new message.
 */
export const CredentialsSchema: GenMessage<Credentials> = /*@__PURE__*/
  messageDesc(file_jira_v1_jira_service, 0);

/**
 * @generated from message jira.v1.Settings
 */
export type Settings = Message<"jira.v1.Settings"> & {
  /**
   * @generated from field: string default_project_key = 1;
   */
  defaultProjectKey: string;

  /**
   * @generated from field: string default_issue_type_name = 2;
   */
  defaultIssueTypeName: string;

  /**
   * @generated from field: string default_subtask_issue_type_name = 3;
   */
  defaultSubtaskIssueTypeName: string;
};

/**
 * Describes the message jira.v1.Settings.
 * Use `create(SettingsSchema)` to create a new message.
 */
export const SettingsSchema: GenMessage<Settings> = /*@__PURE__*/
  messageDesc(file_jira_v1_jira_service, 1);

/**
 * @generated from message jira.v1.SetCredentialsAndSettingsRequest
 */
export type SetCredentialsAndSettingsRequest = Message<"jira.v1.SetCredentialsAndSettingsRequest"> & {
  /**
   * @generated from field: optional jira.v1.Credentials credentials = 1;
   */
  credentials?: Credentials;

  /**
   * @generated from field: optional jira.v1.Settings settings = 2;
   */
  settings?: Settings;
};

/**
 * Describes the message jira.v1.SetCredentialsAndSettingsRequest.
 * Use `create(SetCredentialsAndSettingsRequestSchema)` to create a new message.
 */
export const SetCredentialsAndSettingsRequestSchema: GenMessage<SetCredentialsAndSettingsRequest> = /*@__PURE__*/
  messageDesc(file_jira_v1_jira_service, 2);

/**
 * @generated from message jira.v1.SetCredentialsAndSettingsResponse
 */
export type SetCredentialsAndSettingsResponse = Message<"jira.v1.SetCredentialsAndSettingsResponse"> & {
};

/**
 * Describes the message jira.v1.SetCredentialsAndSettingsResponse.
 * Use `create(SetCredentialsAndSettingsResponseSchema)` to create a new message.
 */
export const SetCredentialsAndSettingsResponseSchema: GenMessage<SetCredentialsAndSettingsResponse> = /*@__PURE__*/
  messageDesc(file_jira_v1_jira_service, 3);

/**
 * @generated from message jira.v1.GetSettingsRequest
 */
export type GetSettingsRequest = Message<"jira.v1.GetSettingsRequest"> & {
};

/**
 * Describes the message jira.v1.GetSettingsRequest.
 * Use `create(GetSettingsRequestSchema)` to create a new message.
 */
export const GetSettingsRequestSchema: GenMessage<GetSettingsRequest> = /*@__PURE__*/
  messageDesc(file_jira_v1_jira_service, 4);

/**
 * @generated from message jira.v1.GetSettingsResponse
 */
export type GetSettingsResponse = Message<"jira.v1.GetSettingsResponse"> & {
  /**
   * @generated from field: jira.v1.Settings settings = 1;
   */
  settings?: Settings;
};

/**
 * Describes the message jira.v1.GetSettingsResponse.
 * Use `create(GetSettingsResponseSchema)` to create a new message.
 */
export const GetSettingsResponseSchema: GenMessage<GetSettingsResponse> = /*@__PURE__*/
  messageDesc(file_jira_v1_jira_service, 5);

/**
 * @generated from message jira.v1.CreateIssueRequest
 */
export type CreateIssueRequest = Message<"jira.v1.CreateIssueRequest"> & {
  /**
   * @generated from field: string org_company_id = 1;
   */
  orgCompanyId: string;

  /**
   * @generated from field: string assessment_id = 2;
   */
  assessmentId: string;

  /**
   * Jira Create issue API
   * https://developer.atlassian.com/cloud/jira/platform/rest/v3/api-group-issues/#api-rest-api-3-issue-post
   *
   * @generated from field: google.protobuf.Struct fields = 3;
   */
  fields?: JsonObject;

  /**
   * Key of parent issue
   *
   * @generated from field: bool subtask = 4;
   */
  subtask: boolean;

  /**
   * @generated from field: optional string parent_key = 5;
   */
  parentKey?: string;
};

/**
 * Describes the message jira.v1.CreateIssueRequest.
 * Use `create(CreateIssueRequestSchema)` to create a new message.
 */
export const CreateIssueRequestSchema: GenMessage<CreateIssueRequest> = /*@__PURE__*/
  messageDesc(file_jira_v1_jira_service, 6);

/**
 * @generated from message jira.v1.CreateIssueResponse
 */
export type CreateIssueResponse = Message<"jira.v1.CreateIssueResponse"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string key = 2;
   */
  key: string;

  /**
   * The URL of the created issue
   *
   * @generated from field: string link = 3;
   */
  link: string;
};

/**
 * Describes the message jira.v1.CreateIssueResponse.
 * Use `create(CreateIssueResponseSchema)` to create a new message.
 */
export const CreateIssueResponseSchema: GenMessage<CreateIssueResponse> = /*@__PURE__*/
  messageDesc(file_jira_v1_jira_service, 7);

/**
 * @generated from message jira.v1.CreateIssuesBulkRequest
 */
export type CreateIssuesBulkRequest = Message<"jira.v1.CreateIssuesBulkRequest"> & {
  /**
   * @generated from field: repeated jira.v1.CreateIssueRequest issues = 1;
   */
  issues: CreateIssueRequest[];
};

/**
 * Describes the message jira.v1.CreateIssuesBulkRequest.
 * Use `create(CreateIssuesBulkRequestSchema)` to create a new message.
 */
export const CreateIssuesBulkRequestSchema: GenMessage<CreateIssuesBulkRequest> = /*@__PURE__*/
  messageDesc(file_jira_v1_jira_service, 8);

/**
 * @generated from message jira.v1.CreateIssuesBulkResponse
 */
export type CreateIssuesBulkResponse = Message<"jira.v1.CreateIssuesBulkResponse"> & {
  /**
   * Successfully created issues (in order of request)
   *
   * @generated from field: repeated jira.v1.CreateIssueResponse issues = 1;
   */
  issues: CreateIssueResponse[];

  /**
   * Errors for failed issues (if any)
   * Each error corresponds to an issue at the same index in the request
   *
   * @generated from field: repeated jira.v1.BulkIssueError errors = 2;
   */
  errors: BulkIssueError[];
};

/**
 * Describes the message jira.v1.CreateIssuesBulkResponse.
 * Use `create(CreateIssuesBulkResponseSchema)` to create a new message.
 */
export const CreateIssuesBulkResponseSchema: GenMessage<CreateIssuesBulkResponse> = /*@__PURE__*/
  messageDesc(file_jira_v1_jira_service, 9);

/**
 * @generated from message jira.v1.BulkIssueError
 */
export type BulkIssueError = Message<"jira.v1.BulkIssueError"> & {
  /**
   * Index of the failed issue in the request (0-based)
   *
   * @generated from field: int32 issue_index = 1;
   */
  issueIndex: number;

  /**
   * Error message
   *
   * @generated from field: string message = 2;
   */
  message: string;

  /**
   * HTTP status code if available
   *
   * @generated from field: int32 status_code = 3;
   */
  statusCode: number;
};

/**
 * Describes the message jira.v1.BulkIssueError.
 * Use `create(BulkIssueErrorSchema)` to create a new message.
 */
export const BulkIssueErrorSchema: GenMessage<BulkIssueError> = /*@__PURE__*/
  messageDesc(file_jira_v1_jira_service, 10);

/**
 * @generated from message jira.v1.ListProjectsRequest
 */
export type ListProjectsRequest = Message<"jira.v1.ListProjectsRequest"> & {
  /**
   * @generated from field: optional jira.v1.Credentials credentials = 1;
   */
  credentials?: Credentials;
};

/**
 * Describes the message jira.v1.ListProjectsRequest.
 * Use `create(ListProjectsRequestSchema)` to create a new message.
 */
export const ListProjectsRequestSchema: GenMessage<ListProjectsRequest> = /*@__PURE__*/
  messageDesc(file_jira_v1_jira_service, 11);

/**
 * @generated from message jira.v1.Project
 */
export type Project = Message<"jira.v1.Project"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string key = 2;
   */
  key: string;

  /**
   * @generated from field: string name = 3;
   */
  name: string;

  /**
   * @generated from field: string url = 4;
   */
  url: string;

  /**
   * @generated from field: map<string, string> avatar_urls = 5;
   */
  avatarUrls: { [key: string]: string };
};

/**
 * Describes the message jira.v1.Project.
 * Use `create(ProjectSchema)` to create a new message.
 */
export const ProjectSchema: GenMessage<Project> = /*@__PURE__*/
  messageDesc(file_jira_v1_jira_service, 12);

/**
 * @generated from message jira.v1.ListProjectsResponse
 */
export type ListProjectsResponse = Message<"jira.v1.ListProjectsResponse"> & {
  /**
   * @generated from field: repeated jira.v1.Project projects = 1;
   */
  projects: Project[];
};

/**
 * Describes the message jira.v1.ListProjectsResponse.
 * Use `create(ListProjectsResponseSchema)` to create a new message.
 */
export const ListProjectsResponseSchema: GenMessage<ListProjectsResponse> = /*@__PURE__*/
  messageDesc(file_jira_v1_jira_service, 13);

/**
 * @generated from message jira.v1.IssueType
 */
export type IssueType = Message<"jira.v1.IssueType"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string description = 3;
   */
  description: string;

  /**
   * @generated from field: string icon_url = 4;
   */
  iconUrl: string;

  /**
   * @generated from field: bool subtask = 5;
   */
  subtask: boolean;
};

/**
 * Describes the message jira.v1.IssueType.
 * Use `create(IssueTypeSchema)` to create a new message.
 */
export const IssueTypeSchema: GenMessage<IssueType> = /*@__PURE__*/
  messageDesc(file_jira_v1_jira_service, 14);

/**
 * @generated from message jira.v1.ListProjectIssueTypesRequest
 */
export type ListProjectIssueTypesRequest = Message<"jira.v1.ListProjectIssueTypesRequest"> & {
  /**
   * @generated from field: optional jira.v1.Credentials credentials = 1;
   */
  credentials?: Credentials;

  /**
   * @generated from field: string project_id = 2;
   */
  projectId: string;
};

/**
 * Describes the message jira.v1.ListProjectIssueTypesRequest.
 * Use `create(ListProjectIssueTypesRequestSchema)` to create a new message.
 */
export const ListProjectIssueTypesRequestSchema: GenMessage<ListProjectIssueTypesRequest> = /*@__PURE__*/
  messageDesc(file_jira_v1_jira_service, 15);

/**
 * @generated from message jira.v1.ListProjectIssueTypesResponse
 */
export type ListProjectIssueTypesResponse = Message<"jira.v1.ListProjectIssueTypesResponse"> & {
  /**
   * @generated from field: repeated jira.v1.IssueType issue_types = 1;
   */
  issueTypes: IssueType[];
};

/**
 * Describes the message jira.v1.ListProjectIssueTypesResponse.
 * Use `create(ListProjectIssueTypesResponseSchema)` to create a new message.
 */
export const ListProjectIssueTypesResponseSchema: GenMessage<ListProjectIssueTypesResponse> = /*@__PURE__*/
  messageDesc(file_jira_v1_jira_service, 16);

/**
 * @generated from message jira.v1.GetIssueTypeMetadataRequest
 */
export type GetIssueTypeMetadataRequest = Message<"jira.v1.GetIssueTypeMetadataRequest"> & {
  /**
   * @generated from field: optional jira.v1.Credentials credentials = 1;
   */
  credentials?: Credentials;

  /**
   * @generated from field: string project_id_or_key = 2;
   */
  projectIdOrKey: string;

  /**
   * @generated from field: string issue_type_id = 3;
   */
  issueTypeId: string;
};

/**
 * Describes the message jira.v1.GetIssueTypeMetadataRequest.
 * Use `create(GetIssueTypeMetadataRequestSchema)` to create a new message.
 */
export const GetIssueTypeMetadataRequestSchema: GenMessage<GetIssueTypeMetadataRequest> = /*@__PURE__*/
  messageDesc(file_jira_v1_jira_service, 17);

/**
 * @generated from message jira.v1.GetIssueTypeMetadataResponse
 */
export type GetIssueTypeMetadataResponse = Message<"jira.v1.GetIssueTypeMetadataResponse"> & {
  /**
   * Metadata about the fields that can/must be set when creating an issue of the specified type in the specified project.
   * API reference: https://developer.atlassian.com/cloud/jira/platform/rest/v3/api-group-issues/#api-rest-api-3-issue-createmeta-projectidorkey-issuetypes-issuetypeid-get
   *
   * @generated from field: repeated google.protobuf.Struct fields = 1;
   */
  fields: JsonObject[];
};

/**
 * Describes the message jira.v1.GetIssueTypeMetadataResponse.
 * Use `create(GetIssueTypeMetadataResponseSchema)` to create a new message.
 */
export const GetIssueTypeMetadataResponseSchema: GenMessage<GetIssueTypeMetadataResponse> = /*@__PURE__*/
  messageDesc(file_jira_v1_jira_service, 18);

/**
 * @generated from message jira.v1.GetCreatedIssuesRequest
 */
export type GetCreatedIssuesRequest = Message<"jira.v1.GetCreatedIssuesRequest"> & {
  /**
   * @generated from field: string org_company_id = 1;
   */
  orgCompanyId: string;
};

/**
 * Describes the message jira.v1.GetCreatedIssuesRequest.
 * Use `create(GetCreatedIssuesRequestSchema)` to create a new message.
 */
export const GetCreatedIssuesRequestSchema: GenMessage<GetCreatedIssuesRequest> = /*@__PURE__*/
  messageDesc(file_jira_v1_jira_service, 19);

/**
 * @generated from message jira.v1.CreatedIssue
 */
export type CreatedIssue = Message<"jira.v1.CreatedIssue"> & {
  /**
   * @generated from field: string assessment_id = 1;
   */
  assessmentId: string;

  /**
   * @generated from field: string issue_id = 2;
   */
  issueId: string;

  /**
   * @generated from field: string issue_key = 3;
   */
  issueKey: string;

  /**
   * @generated from field: string issue_link = 4;
   */
  issueLink: string;

  /**
   * @generated from field: string parent_key = 5;
   */
  parentKey: string;

  /**
   * @generated from field: bool subtask = 6;
   */
  subtask: boolean;
};

/**
 * Describes the message jira.v1.CreatedIssue.
 * Use `create(CreatedIssueSchema)` to create a new message.
 */
export const CreatedIssueSchema: GenMessage<CreatedIssue> = /*@__PURE__*/
  messageDesc(file_jira_v1_jira_service, 20);

/**
 * @generated from message jira.v1.GetCreatedIssuesResponse
 */
export type GetCreatedIssuesResponse = Message<"jira.v1.GetCreatedIssuesResponse"> & {
  /**
   * @generated from field: repeated jira.v1.CreatedIssue issues = 1;
   */
  issues: CreatedIssue[];
};

/**
 * Describes the message jira.v1.GetCreatedIssuesResponse.
 * Use `create(GetCreatedIssuesResponseSchema)` to create a new message.
 */
export const GetCreatedIssuesResponseSchema: GenMessage<GetCreatedIssuesResponse> = /*@__PURE__*/
  messageDesc(file_jira_v1_jira_service, 21);

/**
 * @generated from message jira.v1.DisconnectCreatedIssueRequest
 */
export type DisconnectCreatedIssueRequest = Message<"jira.v1.DisconnectCreatedIssueRequest"> & {
  /**
   * @generated from field: string org_company_id = 1;
   */
  orgCompanyId: string;

  /**
   * @generated from field: string assessment_id = 2;
   */
  assessmentId: string;

  /**
   * @generated from field: string issue_key = 3;
   */
  issueKey: string;
};

/**
 * Describes the message jira.v1.DisconnectCreatedIssueRequest.
 * Use `create(DisconnectCreatedIssueRequestSchema)` to create a new message.
 */
export const DisconnectCreatedIssueRequestSchema: GenMessage<DisconnectCreatedIssueRequest> = /*@__PURE__*/
  messageDesc(file_jira_v1_jira_service, 22);

/**
 * @generated from message jira.v1.DisconnectCreatedIssueResponse
 */
export type DisconnectCreatedIssueResponse = Message<"jira.v1.DisconnectCreatedIssueResponse"> & {
};

/**
 * Describes the message jira.v1.DisconnectCreatedIssueResponse.
 * Use `create(DisconnectCreatedIssueResponseSchema)` to create a new message.
 */
export const DisconnectCreatedIssueResponseSchema: GenMessage<DisconnectCreatedIssueResponse> = /*@__PURE__*/
  messageDesc(file_jira_v1_jira_service, 23);

/**
 * @generated from enum jira.v1.AuthType
 */
export enum AuthType {
  /**
   * @generated from enum value: AUTH_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: AUTH_TYPE_USER_ACCOUNT = 1;
   */
  USER_ACCOUNT = 1,

  /**
   * @generated from enum value: AUTH_TYPE_SERVICE_ACCOUNT = 2;
   */
  SERVICE_ACCOUNT = 2,
}

/**
 * Describes the enum jira.v1.AuthType.
 */
export const AuthTypeSchema: GenEnum<AuthType> = /*@__PURE__*/
  enumDesc(file_jira_v1_jira_service, 0);

/**
 * @generated from service jira.v1.JiraService
 */
export const JiraService: GenService<{
  /**
   * @generated from rpc jira.v1.JiraService.SetCredentialsAndSettings
   */
  setCredentialsAndSettings: {
    methodKind: "unary";
    input: typeof SetCredentialsAndSettingsRequestSchema;
    output: typeof SetCredentialsAndSettingsResponseSchema;
  },
  /**
   * @generated from rpc jira.v1.JiraService.GetSettings
   */
  getSettings: {
    methodKind: "unary";
    input: typeof GetSettingsRequestSchema;
    output: typeof GetSettingsResponseSchema;
  },
  /**
   * @generated from rpc jira.v1.JiraService.CreateIssue
   */
  createIssue: {
    methodKind: "unary";
    input: typeof CreateIssueRequestSchema;
    output: typeof CreateIssueResponseSchema;
  },
  /**
   * @generated from rpc jira.v1.JiraService.CreateIssuesBulk
   */
  createIssuesBulk: {
    methodKind: "unary";
    input: typeof CreateIssuesBulkRequestSchema;
    output: typeof CreateIssuesBulkResponseSchema;
  },
  /**
   * @generated from rpc jira.v1.JiraService.ListProjects
   */
  listProjects: {
    methodKind: "unary";
    input: typeof ListProjectsRequestSchema;
    output: typeof ListProjectsResponseSchema;
  },
  /**
   * @generated from rpc jira.v1.JiraService.ListProjectIssueTypes
   */
  listProjectIssueTypes: {
    methodKind: "unary";
    input: typeof ListProjectIssueTypesRequestSchema;
    output: typeof ListProjectIssueTypesResponseSchema;
  },
  /**
   * @generated from rpc jira.v1.JiraService.GetIssueTypeMetadata
   */
  getIssueTypeMetadata: {
    methodKind: "unary";
    input: typeof GetIssueTypeMetadataRequestSchema;
    output: typeof GetIssueTypeMetadataResponseSchema;
  },
  /**
   * @generated from rpc jira.v1.JiraService.GetCreatedIssues
   */
  getCreatedIssues: {
    methodKind: "unary";
    input: typeof GetCreatedIssuesRequestSchema;
    output: typeof GetCreatedIssuesResponseSchema;
  },
  /**
   * @generated from rpc jira.v1.JiraService.DisconnectCreatedIssue
   */
  disconnectCreatedIssue: {
    methodKind: "unary";
    input: typeof DisconnectCreatedIssueRequestSchema;
    output: typeof DisconnectCreatedIssueResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_jira_v1_jira_service, 0);

